import script from "./SpecificTimesSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpecificTimesSelector.vue?vue&type=script&lang=ts&setup=true"

import "./SpecificTimesSelector.vue?vue&type=style&index=0&id=65e18e7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e18e7b"]])

export default __exports__